// LWI-1563 — generic overrides (Button, TextField, Card, Chip, …) now live
// in src/design-system/theme.js. What stays here is IQ-specific: the
// DataGrid defaults (LWI-595 / LWI-724).
const components = {
  // LWI-595 — surface go-to-first / go-to-last page buttons (`<<` / `>>`)
  // on every DataGrid across the app. The MUI X theme key `MuiDataGrid`
  // covers DataGrid, DataGridPro, and DataGridPremium. `showFirstButton`
  // and `showLastButton` are TablePagination props that GridPagination
  // forwards via prop-spreading. Component-level slotProps still
  // override these defaults if a specific table customises pagination.
  MuiDataGrid: {
    defaultProps: {
      slotProps: {
        pagination: {
          showFirstButton: true,
          showLastButton: true,
        },
        // LWI-724 — the Filters / Columns / Density panels open as a
        // Paper that defaults to background.paper, the same colour as
        // the grid itself, so the panel blends into the table. Switch
        // the panel surface to background.default (a distinct off-white
        // in the theme) and add a thicker border + heavier elevation so
        // the panel reads as a clearly-separated overlay. Component-
        // level slotProps still override these defaults if a specific
        // table customises the panel.
        panel: {
          sx: {
            "& .MuiPaper-root": {
              border: 2,
              borderColor: "divider",
              boxShadow: 16,
              bgcolor: "background.default",
            },
          },
        },
      },
    },
  },
};

export default components;
